<template>
  <div id="top" class="mainWrapper" @click="hideList">
    <!--nav-->
    <head-nav v-bind:gray="gray" v-bind:pos="'fixed'"></head-nav>
    <!--container-->
    <div class="innerWrapper">
      <div
        v-if="status == 0"
        :class="{
          bigShort: (mode == 'on' && curMode == '') || curMode == 'on'
        }"
        class="bigWrp"
      >
        <div class="swiper-wrap">
          <swiper ref="mySwiper" :options="swiperOption">
            <swiper-slide v-for="(val, index) in item.top.imgLst" :key="index">
              <div
                :style="{ backgroundImage: 'url(' + val + ')' }"
                class="img"
                @click="shwImg"
              ></div>
            </swiper-slide>
            <div
              slot="button-prev"
              class="swiper-button-prev"
              @click.prevent
            ></div>
            <div
              slot="button-next"
              class="swiper-button-next"
              @click.prevent
            ></div>
          </swiper>
          <div class="camera" @click="shwImg">
            {{ initialSlide }} / {{ imgList.length }}
          </div>
        </div>
        <div
          :class="{ short: (mode == 'on' && curMode == '') || curMode == 'on' }"
          class="txtWrp"
        >
          <div class="new_lei">
            <h1>${{ item.top.price }}</h1>
            <h2>{{ item.top.proertyType }}</h2>
            <h3>
              <i v-if="item.top.apt">{{ item.top.apt }} / </i
              >{{ item.top.address }} {{ item.top.suburb }}
              <span style="display:block">
                {{ item.top.state }} {{ item.top.postcode }}</span
              >
            </h3>
            <div class="dtl" v-bind:class="'tenant-' + tenant">
              <p>
                <span>Estimated commencement</span
                ><span>{{ item.top.estimatedCommenceMent }}</span>
              </p>
              <p>
                <span>Estimated completion</span
                ><span>{{ item.top.estimatedCompletion }}</span>
              </p>
              <p>
                <span>Estimated rental<br />(per week)</span>
                <span style="margin-top:.05rem"
                  >${{ item.top.rental }}
                  <i
                    v-if="
                      item.top.maxRental &&
                        item.top.maxRental !== 0 &&
                        item.top.maxRental !== '0'
                    "
                    style="font-style:normal"
                  >
                    - ${{ item.top.maxRental }}</i
                  >
                </span>
              </p>
              <p v-if="item.top.proertyType === 'House & Land'">
                <span>Land price</span><span>${{ item.top.landPrice }}</span>
              </p>
              <p v-if="item.top.proertyType === 'House & Land'">
                <span>Build price</span><span>${{ item.top.buildPrice }}</span>
              </p>
              <p>
                <span>Rental yield</span
                ><span>{{ item.top.rentalYield }}%</span>
              </p>
              <p>
                <span>Incentives</span
                ><span v-html="item.top.incentives"></span>
              </p>
            </div>
            <transition name="btn">
              <div
                v-if="mode === 'off' && (curMode === 'off' || curMode === '')"
                class="commision clear"
              >
                <h4>
                  Your commission (inc.GST)<span
                    >${{ item.top.commision }}
                    <i
                      v-if="
                        item.top.maxCommision !== null &&
                          item.top.maxCommision !== undefined &&
                          item.top.maxCommision !== '' &&
                          item.top.maxCommision !== '0' &&
                          item.top.maxCommision !== 0
                      "
                      style="font-style:normal"
                    >
                      - ${{ item.top.maxCommision }}</i
                    ></span
                  >
                </h4>
                <h5>
                  For payment terms please refer to your agreement or contact
                  your UNIFI Representive
                </h5>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div v-if="status == 0" class="detailWrapper">
      <div class="inn">
        <h1 v-bind:class="'tenant-' + tenant">Purchaser's details</h1>
        <div v-for="(purchaser, index) in item.purchasers" :key="index">
          <h2>Purchaser #{{ index + 1 }}</h2>
          <div style="margin-bottom: .48rem;display:flex">
            <p class="clear" style="width:2rem">Name:</p>
            <i
              >{{
                purchaser.firstName && purchaser.firstName !== ""
                  ? purchaser.firstName
                  : "-"
              }}
              {{
                purchaser.surName && purchaser.surName !== ""
                  ? purchaser.surName
                  : "-"
              }}</i
            >
          </div>
          <div style="margin-bottom: .48rem;display:flex">
            <p class="clear" style="width:2rem">Address:</p>
            <i
              >{{
                purchaser.address && purchaser.address !== ""
                  ? purchaser.address
                  : "- "
              }},
              {{
                purchaser.suburb && purchaser.suburb !== ""
                  ? purchaser.suburb
                  : "- "
              }},
              {{
                purchaser.state && purchaser.state !== ""
                  ? purchaser.state
                  : "- "
              }},
              {{
                purchaser.postCode && purchaser.postCode !== ""
                  ? purchaser.postCode
                  : "- "
              }}</i
            >
          </div>
          <div style="margin-bottom: .48rem;display:flex">
            <p class="clear" style="width:2rem">Mobile</p>
            <i>{{
              purchaser.mobile && purchaser.mobile !== ""
                ? purchaser.mobile
                : "-"
            }}</i>
          </div>
          <div style="margin-bottom: .48rem;display:flex">
            <p class="clear" style="width:2rem">Email</p>
            <i>{{
              purchaser.email && purchaser.email !== "" ? purchaser.email : "-"
            }}</i>
          </div>
        </div>
      </div>
    </div>
    <div v-if="status == 0" class="otherWrapper">
      <h1 v-bind:class="'tenant-' + tenant">Documents</h1>
      <div class="btns clear">
        <div class="btn">
          Holding Deposit Receipt
          <a
            v-if="saleContract !== '' && saleContract !== undefined"
            :href="saleContract"
            class="a"
            download
            target="_blank"
            >View</a
          >
          <a v-else class="a" @click="empty">View</a>
        </div>
        <div class="btn">
          Deposit Receipt
          <!--<a v-if="houseForm !== '' && houseForm !==undefined" :href="houseForm" target="_blank" download>View</a>
          <a v-else @click="empty">View</a>-->
          <button @click.stop="showList('showHouseForm')">
            View<i v-if="!showHouseForm" class="el-icon-caret-right"></i
            ><i v-if="showHouseForm" class="el-icon-caret-bottom"></i>
          </button>
          <ul v-if="showHouseForm">
            <li>
              <a
                v-if="
                  houseForm1 !== '' &&
                    houseForm1 !== undefined &&
                    houseForm1 !== null
                "
                :href="houseForm1"
                download
                target="_blank"
                @click.stop="showList"
                >Deposit receipt 1</a
              >
              <a v-else @click.stop="empty">Deposit Receipt 1</a>
            </li>
            <li>
              <a
                v-if="
                  houseForm2 !== '' &&
                    houseForm2 !== undefined &&
                    houseForm2 !== null
                "
                :href="houseForm2"
                download
                target="_blank"
                @click.stop="showList"
                >Deposit receipt 2</a
              >
              <a v-else @click.stop="empty">Deposit Receipt 2</a>
            </li>
            <li>
              <a
                v-if="
                  houseForm3 !== '' &&
                    houseForm3 !== undefined &&
                    houseForm3 !== null
                "
                :href="houseForm3"
                download
                target="_blank"
                @click.stop="showList"
                >Deposit receipt 3</a
              >
              <a v-else @click.stop="empty">Deposit Receipt 3</a>
            </li>
          </ul>
        </div>

        <div class="btn">
          Sale Contract
          <button @click.stop="showList('showsaleContractTwo')">
            View<i v-if="!showsaleContractTwo" class="el-icon-caret-right"></i
            ><i v-if="showsaleContractTwo" class="el-icon-caret-bottom"></i>
          </button>
          <ul v-if="showsaleContractTwo">
            <li>
              <a
                v-if="
                  saleContractTwo1 !== '' &&
                    saleContractTwo1 !== undefined &&
                    saleContractTwo1 !== null
                "
                :href="saleContractTwo1"
                download
                target="_blank"
                @click.stop="showList"
                >Sale Contract 1</a
              >
              <a v-else @click.stop="empty">Sale Contract 1</a>
            </li>
            <li>
              <a
                v-if="
                  saleContractTwo2 !== '' &&
                    saleContractTwo2 !== undefined &&
                    saleContractTwo2 !== null
                "
                :href="saleContractTwo2"
                download
                target="_blank"
                @click.stop="showList"
                >Sale Contract 2</a
              >
              <a v-else @click.stop="empty">Sale Contract 2</a>
            </li>
          </ul>
        </div>
        <div class="btn">
          Form 1
          <a
            v-if="sectionPdf !== '' && sectionPdf !== undefined"
            :href="sectionPdf"
            class="a"
            download
            target="_blank"
            >View</a
          >
          <a v-else class="a" @click="empty">View</a>
        </div>
        <div class="btn">
          Additional Documents

          <button @click.stop="showList('showAddition')">
            View<i v-if="!showAddition" class="el-icon-caret-right"></i
            ><i v-if="showAddition" class="el-icon-caret-bottom"></i>
          </button>
          <ul v-if="showAddition" style="width:4rem">
            <li>
              <a
                v-if="
                  addition1 !== '' &&
                    addition1 !== undefined &&
                    addition1 !== null
                "
                :href="addition1"
                download
                target="_blank"
                @click.stop="showList"
                >Additional Documents 1</a
              >
              <a v-else @click.stop="empty">Additional Documents 1</a>
            </li>
            <li>
              <a
                v-if="
                  addition2 !== '' &&
                    addition2 !== undefined &&
                    addition2 !== null
                "
                :href="addition2"
                download
                target="_blank"
                @click.stop="showList"
                >Additional Documents 2</a
              >
              <a v-else @click.stop="empty">Additional Documents 2</a>
            </li>
            <li>
              <a
                v-if="
                  addition3 !== '' &&
                    addition3 !== undefined &&
                    addition3 !== null
                "
                :href="addition3"
                download
                target="_blank"
                @click.stop="showList"
                >Additional Documents 3</a
              >
              <a v-else @click.stop="empty">Additional Documents 3</a>
            </li>
            <li>
              <a
                v-if="
                  addition4 !== '' &&
                    addition4 !== undefined &&
                    addition4 !== null
                "
                :href="addition4"
                download
                target="_blank"
                @click.stop="showList"
                >Additional Documents 4</a
              >
              <a v-else @click.stop="empty">Additional Documents 4</a>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="datum[0] !== 0">
        <div v-for="(con, ix) in datum" :key="ix" class="other">
          <div class="top clear">
            <div class="tit">
              <h3>{{ con.title }}</h3>
              <h4>Posted {{ con.createTime }}</h4>
            </div>
            <button @click="toLst">View all updates <span>></span></button>
          </div>
          <ul class="middle">
            <li
              v-for="(img, i) in con.imgLst"
              :key="i"
              :style="{ backgroundImage: 'url(' + img + ')' }"
            ></li>
            <div
              v-if="con.imgLst && con.imgLst.length > 5"
              class="more"
              @click="toDtl(con.constructionId)"
            >
              <p>+ {{ con.imgLst.length - 4 }} More</p>
            </div>
          </ul>
          <div class="bom">
            <p v-html="con.description"></p>
            <div class="link" @click="toDtl(con.constructionId)">
              VIEW FULL UPDATE
            </div>
          </div>
        </div>
      </div>
      <div class="btn">
        Recommended Service Providers
        <button @click="toService">View</button>
      </div>
    </div>
    <!--footer-->
    <foot-nav></foot-nav>
    <!--大图-->
    <!-- <b-img @accept="instructClose" v-if="showEl" v-bind:url="URL" v-bind:type="'img'"></b-img> -->
    <van-image-preview v-model="showEl" :images="bigImgList" @change="onChange">
      <!--<template v-slot:index>第{{ index }}页</template>-->
    </van-image-preview>
  </div>
</template>

<script>
import headNav from "@/components/package/nav";
import footNav from "@/components/package/footer";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapActions, mapMutations, mapState } from "vuex";
import bImg from "@/components/package/bImg";

export default {
  data() {
    const self = this;
    return {
      item: {
        top: {},
        purchasers: []
      },
      datum: [],
      gray: true,
      initialSlide: 1,
      imgList: [],
      bigImgList: [],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          loop: true
        },
        on: {
          slideChangeTransitionEnd: function() {
            self.initialSlide = this.activeIndex + 1;
          }
        }
      },
      mode: "off",
      status: 1,
      showEl: false,
      saleContract: "",
      houseForm: "",
      showsaleContractTwo: false,
      saleContractTwo1: "",
      saleContractTwo2: "",
      sectionPdf: "",
      index: "",
      showHouseForm: false,
      houseForm1: "",
      houseForm2: "",
      houseForm3: "",
      showAddition: false,
      addition1: "",
      addition2: "",
      addition3: "",
      addition4: "",
      tenant: window.location.hostname
        .replace("m.", "")
        .split(".")[0]
        .split("testunifiproperty")[0]
        .split("unifiproperty")[0]
        .split("platform")[0]
    };
  },
  created() {
    var that = this;
    localStorage.setItem("propertyId", that.$route.params.id);
    // 这里是获取上方详情的接口
    that.getPropertyDtl({
      params: that.$route.params.orderId,
      callback: that.callback
    });
    // 这里是获取施工信息的接口
    that.getLst({
      params: that.$route.params.id,
      callback: that.constructionCallback
    });
    // 获取pdf链接 需要下载
    /*  that.getPdf({params: {
          id: that.$route.params.id,
          roomId: that.$route.params.roomId
      }, callback: that.pdfCallback})*/
    if (localStorage.getItem("mode")) {
      that.mode = localStorage.getItem("mode");
      that.change({ data: that.mode });
    }
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  },
  methods: {
    showList(type) {
      if (type === "showHouseForm") {
        this.showHouseForm = !this.showHouseForm;
        this.showsaleContractTwo = false;
        this.showAddition = false;
      } else if (type === "showsaleContractTwo") {
        this.showsaleContractTwo = !this.showsaleContractTwo;
        this.showHouseForm = false;
        this.showAddition = false;
      } else if (type === "showAddition") {
        this.showAddition = !this.showAddition;
        this.showsaleContractTwo = false;
        this.showHouseForm = false;
      }
    },
    hideList() {
      this.showHouseForm = false;
      this.showsaleContractTwo = false;
      this.showAddition = false;
    },
    ...mapMutations("login", ["change"]),
    shwImg(url) {
      var that = this;
      that.showEl = true;
      that.index = 1;
      that.bigImgList = [];
      let lgt = that.imgList.length;
      for (let i = that.initialSlide - 1; i < lgt; i++) {
        that.bigImgList.push(that.imgList[i]);
      }
      if (that.initialSlide > 1) {
        let preList = [];
        for (let i = 0; i < that.initialSlide - 1; i++) {
          preList.push(that.imgList[i]);
        }
        that.bigImgList = that.bigImgList.concat(preList);
      }
    },
    onChange(index) {
      this.index = index + 1;
    },
    empty() {
      var that = this;
      that.$box.alert("", "No content yet.", "error");
      that.showHouseForm = false;
    },
    // 打开大图
    openImg(img) {
      var that = this;
      that.URL = img;
      this.showEl = true;
    },
    instructClose() {
      this.showEl = false;
    },
    ...mapActions("purchase", ["getPropertyDtl", "getPdf"]),
    ...mapActions("construction", ["getLst"]),
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.saleContract = res.data.data.ordersPOJO.contracePdfUrl;
        that.houseForm1 = res.data.data.ordersPOJO.formOneUrl;
        that.houseForm2 = res.data.data.ordersPOJO.deposit2Pdf;
        that.houseForm3 = res.data.data.ordersPOJO.deposit3Pdf;
        that.saleContractTwo1 = res.data.data.ordersPOJO.saleContractPdf;
        that.saleContractTwo2 = res.data.data.ordersPOJO.saleContract2Pdf;
        that.sectionPdf = res.data.data.ordersPOJO.sectionPdf;
        that.addition1 = res.data.data.ordersPOJO.addition1Pdf;
        that.addition2 = res.data.data.ordersPOJO.addition2Pdf;
        that.addition3 = res.data.data.ordersPOJO.addition3Pdf;
        that.addition4 = res.data.data.ordersPOJO.addition4Pdf;

        that.status = 0;
        var datum = res.data.data.housePropertyPOJO;
        if (datum.imageUrl) {
          if (datum.imageUrl.indexOf(",") !== -1) {
            datum.imgLst = datum.imageUrl.split(",");
          } else {
            datum.imgLst = [datum.imageUrl];
          }
        }
        if (datum.imgLst) {
          that.imgList = datum.imgLst;
        }
        datum.commision = that.$box.formatSplit(
          parseInt(datum.commission),
          true
        );

        datum.maxRental = that.$box.formatSplit(datum.maxRental, true);
        datum.rental = that.$box.formatSplit(datum.rental, true);
        datum.maxCommision =
          datum.maxCommision !== ""
            ? that.$box.formatSplit(parseInt(datum.maxCommision), true)
            : "";
        datum.price =
          res.data.data.houseRoomPojosList[0].revisedPrice !== ""
            ? that.$box.formatSplit(
                res.data.data.houseRoomPojosList[0].revisedPrice,
                true
              )
            : "";
        datum.maxPrice =
          datum.maxPrice !== ""
            ? that.$box.formatSplit(datum.maxPrice, true)
            : "";

        datum.landPrice =
          datum.landPrice !== ""
            ? that.$box.formatSplit(datum.landPrice, true)
            : "";
        datum.buildPrice =
          datum.buildPrice !== ""
            ? that.$box.formatSplit(datum.buildPrice, true)
            : "";

        datum.bedsNumber = res.data.data.houseRoomPojosList[0].beds
          ? res.data.data.houseRoomPojosList[0].beds
          : "";
        datum.apt = res.data.data.houseRoomPojosList[0].apt
          ? res.data.data.houseRoomPojosList[0].apt
          : null;

        res.data.data.ordersPurchaserPOJOList.forEach(v => {
          v.mobile = that.$box.formatTelNumber(v.mobile);
        });
        that.item = {
          top: datum,
          purchasers: res.data.data.ordersPurchaserPOJOList
        };
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 40010) {
        that.$router.push("/");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    constructionCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        res.data.data.forEach(v => {
          if (v.imageUrl) {
            if (v.imageUrl.indexOf(",") !== -1) {
              v.imgLst = v.imageUrl.split(",");
            } else {
              v.imgLst = [v.imageUrl];
            }
          }
          v.createTime = that.$box.formatTimestamp(v.createTime);
        });
        var lastest = [res.data.data[0]];
        if (res.data.data.length > 0) that.datum = lastest;
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
    pdfCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.saleContract = res.data.data.saleContract;
        that.houseForm1 = res.data.data.houseForm;
        that.houseForm2 = res.data.data.deposit2Pdf;
        that.houseForm3 = res.data.data.deposit3Pdf;
        that.saleContractTwo1 = res.data.data.saleContractTwo;
        that.saleContractTwo2 = res.data.data.saleContract2Pdf;
        that.sectionPdf = res.data.data.sectionPdf;
        that.addition1 = res.data.data.addition1Pdf;
        that.addition2 = res.data.data.addition2Pdf;
        that.addition3 = res.data.data.addition3Pdf;
        that.addition4 = res.data.data.addition4Pdf;
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
    toLst() {
      var that = this;
      that.$router.push(`/account/list/${that.$route.params.id}`);
    },
    toDtl(res) {
      var that = this;
      that.$router.push(
        `/account/inner/${res}/dtl/${that.$route.params.id}/${that.$route.params.roomId}/${that.$route.params.orderId}`
      );
    },
    toService() {
      var that = this;
      that.$router.push(`/account/recommend/${that.$route.params.id}`);
    }
  },
  components: {
    headNav,
    footNav,
    swiper,
    swiperSlide,
    bImg
  },
  computed: {
    ...mapState({
      curMode: state => state.login.mode, // 实时变化
      pdf: state => state.purchase.pdf
    })
  },
  watch: {
    curMode(val) {
      this.mode = localStorage.getItem("mode");
    }
  }
};
</script>

<style lang="scss" scoped>
.mainWrapper {
  width: 100%;
  position: relative;
}

.innerWrapper {
  width: 100%;
  margin: 0 auto;
  padding-top: 1.04rem;
  box-sizing: border-box;

  .bigWrp {
    width: 100%;
    margin-bottom: 56px;
    transition: all 0.5s;
    margin-bottom: 0.64rem !important;

    .swiper-wrap {
      position: relative;
      width: 100%;
      height: 5rem;

      .img {
        width: 100%;
        height: 5rem;
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        background-color: #3f3f46;
        cursor: pointer;
      }

      .camera {
        position: absolute;
        width: 2.05rem;
        height: 0.68rem;
        left: 50%;
        top: 3.96rem;
        font-weight: 600;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        z-index: 10;
        background-color: #3f3f46;
        border-radius: 5px;
        background-repeat: no-repeat;
        background-position: -6px center;
        background-size: contain;
        background-image: url("../../assets/4.png");
        box-sizing: border-box;
        line-height: 0.68rem;
        font-size: 0.32rem;
        padding-left: 0.8rem;
        color: #fff;
        font-weight: normal;
        text-align: center;
        cursor: pointer;
        padding-right: 0.3rem;
      }
    }

    .collect {
      position: absolute;
      top: 0;
      left: 0;
      width: 0.6rem;
      height: 0.6rem;
      background-position: center center;
      background-repeat: no-repeat;
      z-index: 5;
      cursor: pointer;
    }

    .notCollected {
      background-image: url("../../assets/tag.png");
    }

    .collected {
      background-image: url("../../assets/tag2.png");
    }
  }

  .txtWrp {
    padding: 0 0.24rem;
    box-sizing: border-box;

    .new_lei {
      z-index: 2;
      width: 100%;
      box-sizing: border-box;
      padding: 0.5rem 0.32rem;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.06);
      border-radius: 3px;
      border: 1px solid rgba(247, 247, 250, 1);
      position: relative;
      top: -0.24rem;
      overflow: hidden;
      transition: all 0.5s;

      h1 {
        color: #3f3f46;
        margin-bottom: 1px;
        font-size: 0.32rem;
        line-height: 0.38rem;
        text-align: right;
      }

      h2 {
        color: #979497;
        font-size: 0.24rem;
        line-height: 0.28rem;
        margin-bottom: 0.1rem;
      }

      h3 {
        font-size: 0.52rem;
        color: #3f3f46;
        line-height: 0.62rem;
        margin-bottom: 0.12rem;

        span {
          font-size: 0.4rem;
          line-height: 0.48rem;
          // margin-left: .15rem;
          color: #979497;
        }

        i {
          font-style: normal;
        }
      }

      .dtl {
        width: 100%;
        position: relative;
        padding: 0.06rem 0;
        margin-bottom: 0.22rem;

        p {
          font-size: 0.28rem;
          color: #979497;
          margin-bottom: 0.1rem;
          display: flex;
          flex-direction: row;

          span:nth-child(1) {
            flex: 0 0 auto;
            width: 3.2rem;
            text-align: right;
            vertical-align: top;
            margin-right: 0.35rem;
          }

          span:nth-child(2) {
            flex: 1;
            color: #3f3f46;
            display: inline-block;
            word-break: break-word;
          }
        }

        p:nth-last-child(1) {
          margin: 0;
        }
      }

      .dtl:after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 0.1rem;
        height: 2.3rem;
        //background:rgba(255,239,0,1);
      }

      .commision {
        height: 2.9rem;
        background: rgba(63, 63, 70, 1);
        border-radius: 3px;
        box-sizing: border-box;
        padding: 0 0.16rem;
        color: #e5e5e5;

        h4 {
          font-size: 0.28rem;
          line-height: 0.34rem;
          border-bottom: 1px solid #fff;
          padding-bottom: 0.36rem;
          padding-top: 0.36rem;

          span {
            font-size: 0.4rem;
            float: right;
            color: #eaeaeb;
          }
        }

        h5 {
          margin-top: 0.48rem;
          font-size: 0.28rem;
          line-height: 0.36rem;
          text-align: center;
          word-break: break-word;
          // span{
          //     margin: 0 10px;
          // }
        }
      }
    }
  }
}

.detailWrapper {
  width: 100%;
  background: #f5f5f7;
  padding: 0.64rem 0.34rem;
  margin-bottom: 0.64rem;
  box-sizing: border-box;

  .inn {
    width: 100%;
    margin: 0 auto;

    h1 {
      font-size: 0.48rem;
      color: #333333;
      line-height: 0.58rem;
      position: relative;
      margin-bottom: 0.78rem;
    }

    h2 {
      margin-bottom: 0.38rem;
      color: #333333;
      font-size: 0.32rem;
      font-family: ProximaNova-Semibold;
    }

    h1:after {
      content: "";
      width: 1.16rem;
      height: 0.06rem;
      display: block;
      position: absolute;
      left: 0;
      bottom: -6px;
      //background: #FFEF00;
    }

    p {
      color: #8f8f8f;
      font-size: 0.3rem;
      line-height: 0.36rem;
      display: inline-block;
    }

    i {
      font-size: 0.3rem;
      line-height: 0.36rem;
      // min-width: 4rem;
      font-style: normal;
      color: #3f3f46;
      // float: right;
      flex: 1;
      // margin-left: auto;
      text-align: right;
    }
  }
}

.otherWrapper {
  width: 100%;
  margin: 0 auto 0.68rem auto;
  box-sizing: border-box;
  padding: 0 0.24rem;

  h1 {
    font-size: 0.48rem;
    color: #333333;
    line-height: 0.58rem;
    position: relative;
    margin-bottom: 0.78rem;
  }

  h1:after {
    content: "";
    width: 1.16rem;
    height: 0.06rem;
    display: block;
    position: absolute;
    left: 0;
    bottom: -6px;
    //background: #FFEF00;
  }

  .btns {
    width: 100%;

    .btn {
      width: 100%;
      float: left;
    }
  }

  .btn {
    width: 100%;
    box-sizing: border-box;
    height: 1.28rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.06);
    border-radius: 2px;
    border: 1px solid rgba(247, 247, 250, 1);
    margin-bottom: 0.16rem;
    padding: 0 0.32rem;
    line-height: 1.28rem;
    color: #333333;
    font-size: 0.32rem;
    position: relative;

    button {
      width: 1.12rem;
      float: right;
      border: none;
      text-align: center;
      line-height: 0.56rem;
      height: 0.56rem;
      background: rgba(44, 202, 115, 1);
      border-radius: 6px;
      font-size: 0.26rem;
      color: #fff;
      margin-top: 0.36rem;
      padding: 0 0.2rem;
      cursor: pointer;
      position: relative;

      i {
        position: absolute;
        font-size: 0.28rem;
        right: 0rem;
        top: 0.15rem;
      }
    }

    .a {
      text-decoration: none;
      float: right;
      border: none;
      text-align: center;
      line-height: 0.56rem;
      width: 1.12rem;
      height: 0.56rem;
      background: rgba(44, 202, 115, 1);
      border-radius: 6px;
      font-size: 0.28rem;
      color: #fff;
      margin-top: 0.36rem;
      cursor: pointer;
    }

    ul {
      position: absolute;
      right: 0.3rem;
      top: 1rem;
      width: 3.6rem;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #dee3e0;
      z-index: 2;

      li {
        line-height: 1.04rem;
        text-align: center;
        cursor: pointer;

        a {
          text-decoration: none;
          color: #333;
          display: block;
          line-height: 1.04rem;
          width: 100%;
        }

        a:active {
          display: block;
          line-height: 1.04rem;
          width: 100%;
          background: #2cca73;
          color: #fff;
        }
      }
    }
  }

  .other {
    width: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.06);
    border-radius: 3px;
    border: 1px solid rgba(247, 247, 250, 1);
    margin-bottom: 0.6rem;
    box-sizing: border-box;
    padding: 0.48rem 0.32rem;

    .top {
      margin-bottom: 0.48rem;
      display: flex;

      .tit {
        width: 50%;
        float: left;

        h3 {
          font-size: 0.34rem;
          line-height: 0.36rem;
          color: #333333;
          margin-bottom: 0.08rem;
          font-family: ProximaNova-Semibold;
        }

        h4 {
          width: 100%;
          font-size: 0.28rem;
          line-height: 0.34rem;
          color: #8e8c8f;
        }
      }

      button {
        margin-left: auto;
        border: none;
        display: block;
        float: right;
        height: 0.56rem;
        background: rgba(44, 202, 115, 1);
        border-radius: 6px;
        line-height: 0.56rem;
        text-align: center;
        color: #fff;
        font-size: 0.24rem;
        cursor: pointer;

        span {
          font-family: ProximaNova-Semibold;
          margin-left: 10px;
        }
      }
    }

    .middle {
      margin-bottom: 0.48rem;
      height: 3.16rem;
      position: relative;

      li {
        position: absolute;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        border-radius: 3px;
        background-color: #f5f6f8;
        width: 0;
        height: 0;
        overflow: hidden;
      }

      li:nth-child(1) {
        width: 3.16rem;
        height: 3.16rem;
        left: 0;
        top: 0;
      }

      li:nth-child(2) {
        left: 3.2rem;
        top: 0;
        width: 1.54rem;
        height: 1.54rem;
      }

      li:nth-child(3) {
        right: 0;
        top: 0;
        width: 1.54rem;
        height: 1.54rem;
      }

      li:nth-child(4) {
        left: 3.2rem;
        bottom: 0;
        width: 1.54rem;
        height: 1.54rem;
      }

      li:nth-child(5) {
        right: 0;
        bottom: 0;
        width: 1.54rem;
        height: 1.54rem;
      }

      .more {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 1.54rem;
        height: 1.54rem;
        background: rgba(0, 0, 0, 0.6);
        z-index: 1;
        cursor: pointer;

        p {
          font-size: 0.28rem;
          text-align: center;
          line-height: 1.54rem;
          color: #fff;
        }
      }
    }

    .bom {
      height: 2.1rem;
      overflow: hidden;
      position: relative;

      p {
        font-size: 0.28rem;
        line-height: 0.42rem;
        color: #3f3f46;
      }

      .link {
        position: absolute;
        bottom: 0.03rem;
        width: 3rem;
        right: 0;
        font-size: 0.26rem;
        color: #2cca73;
        text-decoration: underline;
        background: #fff;
        box-shadow: -29px 0 13px -1px rgba(252, 255, 255, 1);
        cursor: pointer;
      }
    }
  }
}

.swiper-button-prev {
  background-image: url("../../assets/p.png");
  background-size: 40px 40px;
  width: 40px;
  height: 40px;
  left: 15px;
}

.swiper-button-next {
  background-image: url("../../assets/n.png");
  background-size: 40px 40px;
  width: 40px;
  height: 40px;
  right: 15px;
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  opacity: 0;
}

.btn-enter-active,
.btn-leave-active {
  transition: opacity 0.5s;
}

.btn-enter,
.btn-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/account/reserveDtl.vue